import React from "react";
import { Link } from "react-router-dom";
import FooterBottom from "./FooterBottom";

import footerLogo1 from "../../../assets/img/logo/Metaqualt_Logo_ff.png";

const Footer = (props) => {
  const { footerLogo, footerClass } = props;

  return (
    <footer className={footerClass ? footerClass : "rs-footer"}>
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6 mb-10">
              <div className="footer-panel">
                <div className="footer-logo">
                  <Link to="/">
                    <img src={footerLogo ? footerLogo : footerLogo1} alt="MetaQualt Logo" />
                  </Link>
                </div>
                <div className="textwidget pb-30">
                  <p>
                    With 16+ years of experience, MetaQualt focuses on DeepTech
                    solutions in Blockchain and AI, using the latest tools and
                    techniques to turn bold ideas into intelligent, secure, and
                    scalable digital products.
                  </p>
                </div>
                <ul className="footer-social md-mb-30">
                  <li>
                    <a
                      href="https://www.facebook.com/metaqualt"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="MetaQualt Facebook"
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/metaqualt"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="MetaQualt X"
                    >
                      <i className="fa-brands fa-x-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/metaqualt/"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="MetaQualt LinkedIn"
                    >
                      <i className="fa-brands fa-linkedin-in"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/metaqualt/"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="MetaQualt Instagram"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 mb-10">
              <div className="footer-panel">
                <h3 className="widget-title">Our Services</h3>
                <ul className="site-map">
                  <li>
                    <Link to="/AI-LLM-Solutions">AI & LLM Solutions</Link>
                  </li>
                  <li>
                    <Link to="/salesforce-consulting">
                      Salesforce Consulting
                    </Link>
                  </li>
                  <li>
                    <Link to="/staff-augmentation">
                      Staff Augmentation (Dedicated Teams)
                    </Link>
                  </li>
                  <li>
                    <Link to="/blockchain">Blockchain Services</Link>
                  </li>
                  <li>
                    <Link to="/web-mobile-app-development">
                      Web & Mobile App Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/fintech-app-engineering">
                      Fintech Application Engineering
                    </Link>
                  </li>
                  <li>
                    <Link to="/cloud-devops">Cloud & DevOps</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 mb-10">
              <div className="footer-panel">
                <h3 className="widget-title">Solutions</h3>
                <ul className="site-map">
                  <li>
                    <a href="https://www.voicerix.ai" target="_blank" rel="noreferrer">
                      VoiceRix
                    </a>
                  </li>

                  <li>
                    <span className="coming-soon-link">Opteev</span>
                  </li>
                  <li>
                    <a href="https://tradicorn.com/" target="_blank" rel="noreferrer">
                      Tradicorn
                    </a>
                  </li>
                  <li>
                    <span className="coming-soon-link">Eaglient</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div className="col-lg-3 col-md-6 col-sm-6 mb-30">
              <h3 className="widget-title">Our Solution</h3>
              <ul className="site-map">
                <li>
                  <Link to="/fintech-app-solution">Fintech App Solutions</Link>
                </li>
                <li>
                  <Link to="/devops-solutions">
                    DevOps Solutions
                  </Link>
                </li>
                <li>
                  <Link to="/startup-solutions">StartUp Solutions</Link>
                </li>
                
                <li>
                  <Link to="/cloud-solutions">
                    Cloud Solutions
                  </Link>
                </li>
                <li>
                  <Link to="/salesforce-implementation">
                    Salesforce Implementation
                  </Link>
                </li>
                <li>
                  <Link to="/ecommerce-solutions">e-commerce App Solutions</Link>
                </li>
              </ul>
            </div> */}
            <div className="col-lg-3 col-md-6 col-sm-6 mb-10">
              <div className="footer-panel">
                <h3 className="widget-title">Contact Info</h3>
                <ul className="address-widget">
                  <li>
                    <i className="flaticon-location"> </i>
                    <div className="desc">
                      Office: 417-418, Satyamev Eminence, Science City Rd, Sola,
                      Ahmedabad, Gujarat 380060
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-call"></i>
                    <div className="desc">
                      <a href="tel:+917096069000">+91 7096069000</a>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-email"></i>
                    <div className="desc">
                      <a href="mailto:biz@metaqualt.com">biz@metaqualt.com</a>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-clock"></i>
                    <div className="desc">Opening Hours: 09:30 - 18:30</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterBottom />
    </footer>
  );
};

export default Footer;
